// extracted by mini-css-extract-plugin
module.exports = {"root":"IconAttachMoney_root__nNw-Z"};